export default __webpack_public_path__ + "static/media/facebook.55f1b6ae.png";